import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classnames from 'classnames';
import { getSelection } from '../selectors';

const Selection = ({ selection }) => (
  <li className="settled-selection" key={selection.selectionUniqueId}>
    <div className="settled-selection__details">
      <div>{selection.selectionLabel.replace(new RegExp('\\?(?=\\d)'), '£')}</div>
      <div>{selection.marketName}</div>
      <div>{selection.eventName}</div>
    </div>
    <div className="settled-selection__result">
      {
        selection.selectionResult
          ? (
            <div
              className={classnames({
                'settled-selection__badge': true,
                'selection-result-badge': true,
                'selection-result-badge--won': selection.selectionResult === 'Win'
              })}
            >
              {selection.selectionResult}
            </div>
          ) : null
      }
    </div>
  </li>
);

Selection.propTypes = {
  selection: PropTypes.object.isRequired
};

const mapStateToProps = (initialState, initialProps) => (state) => ({
  selection: getSelection(state, initialProps)
});

export default connect(mapStateToProps)(Selection);
